// extracted by mini-css-extract-plugin
export var suptitle = "styles-module--suptitle--f00c9";